import { Component } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
import styled from 'styled-components';
import withTheme from 'ContentComponents/cmv2/decorators/withTheme';
// @ts-expect-error No types
import CodeMirror from 'ContentComponents/codeMirror/CodeMirror';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledCodeMirror = styled(CodeMirror)(({
  foundationsTheme,
  useOnDark
}) => `
  min-height: 200px;
  border-radius: ${foundationsTheme.borderRadius['100']};
  border: ${foundationsTheme.borderWidth['100']} solid ${foundationsTheme.color['border-core-default']};
  ${useOnDark && `.cm-s-hubspot-canvas-light { background-color: ${foundationsTheme.color['fill-surface-default']}; }`}
`);
class Html extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }
  onChange({
    value
  }) {
    const {
      onFieldChange = emptyFunction
    } = this.props;
    onFieldChange(value);
  }
  render() {
    const {
      codeMirrorProps,
      readOnly,
      theme,
      useOnDark,
      value = ''
    } = this.props;
    return /*#__PURE__*/_jsx(StyledCodeMirror, Object.assign({
      foundationsTheme: theme,
      readOnly: readOnly,
      mode: "htmlmixed",
      onChange: this.onChange,
      useOnDark: useOnDark,
      value: value
    }, codeMirrorProps));
  }
}
export default withTheme(Html);